<template>
	<div class="card">
		<div class="card-title">6. 网页模拟器</div>
		<div class="row">
			<div class="label">头部标题</div>
			<input :value="value.title" @input="updateTitle" style="width:280px" :disabled="vimSave" />
		</div>
		<div style="margin-top:10px;">
			<span>网页文件:</span>
			<div style="border:1px solid #eee; border-radius:6px; margin:8px 0;">
				<!-- 表头 -->
				<div style="display:flex; padding:10px 16px; background:#f7f8fa; font-weight:500;">
					<div style="width:220px;">网页选择</div>
					<div style="width:120px;">网页名称</div>
					<div style="width:160px;">操作</div>
				</div>
				<!-- 循环每行网页条目 -->
				<div v-for="(htmlItem, index) in value.htmlList" :key="index"
					style="display:flex; align-items:center; padding:12px 16px; border-top:1px solid #eee;">
					<!-- 每行独立下拉选择 -->
					<div style="width:220px;">
						<el-select v-model="htmlItem.id" placeholder="选择网页文件"
							@change="(val) => handleChangeSingle(index, val)" style="width:200px">
							<el-option v-for="item in HtmlList" :key="item.id" :label="item.htmlName"
								:value="item.id"></el-option>
						</el-select>
					</div>
					<!-- 显示当前选中名称 -->
					<div style="width:120px;">
						<span>{{ htmlItem.typeName }}</span>
					</div>
					<!-- 操作按钮：模拟测试 + 删除 -->
					<div style="width:160px; display:flex; gap:8px;">
						<el-button size="mini" type="success" @click="viewHtml(index)"
							v-if="htmlItem.src">模拟测试</el-button>
						<el-button size="mini" type="text" v-if="(index+1)==value.htmlList.length&&index!=0"
							@click="clearSingleFiler(index)">删除</el-button>
					</div>
				</div>
			</div>
			<!-- <el-button size="mini" @click="addNewHtmlRow">+ 添加网页</el-button> -->
		</div>

		<!-- 全屏弹窗 -->
		<el-dialog title="网页模拟器预览" :visible.sync="dialogVisible" width="100%" top="0" :before-close="handleCloseDialog"
			:modal-append-to-body="true" style="overflow-y: hidden;height:100%;">
			<div style=" width:100%;height:calc(100vh - 120px);">
				<HtmlPlayView :key="dialogKey" :iframeUrlOrigin="iframeUrlOrigin" :iframeUrlPlay="iframeUrlPlay" />
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		HtmlToOss,
		injectCubePostMessage
	} from '../../../../../js/img.js';
	import HtmlPlayView from '../../../../../views/components/html/HtmlIframeView.vue'
	export default {
		components: {
			HtmlPlayView
		},
		props: {

			value: {
				type: Object,
				default: () => ({
					title: '',
					htmlList: []
				})
			},

			vimSave: {
				type: Boolean,
				default: false,
			},
			courseClassId: {
				type: Number,
				default: null,
			}
		},
		data() {
			return {
				dialogVisible: false,
				uploadFileName: '',
				rawHtml: '',
				processedHtml: "",
				iframeUrlOrigin: '',
				iframeUrlPlay: '',
				cachePlaySnapshot: '',
				login: null,
				dialogKey: 0,
				year: '',
				term: '',
				file: null,
				iframeSrc: null,
				isSrc: false,
				htmlSimulation: false,
				HtmlList: []
			}
		},
		watch: {
			// value(newVal){
			// 	console.log('newVal',newVal)
			// }
		},
		mounted() {

		},
		created() {
			this.forHtmlSimulation()
			this.forHtmlList()
			if (this.value.htmlList[0]) {
				this.uploadFileName = this.value.htmlList[0].typeName
				let src = this.value.htmlList[0].src
				if (src) {
					this.isSrc = true
				} else {
					this.isSrc = false
				}
			}
			if (localStorage.getItem('semester')) {
				let semesterList = JSON.parse(localStorage.getItem('semester'))

				let arr = semesterList.filter(v => v.status == 1)[0] || {}
				if (arr) {
					this.year = Number(arr.year)
					this.term = arr.term
				}
			}
		},
		methods: {
			async forHtmlList() {
				try {
					const res = await this.API.get(this.API.admin.getStandardModelSimple, {
						authType: 1
					})
					this.HtmlList = res.data.data || []

				} catch (err) {
					this.HtmlList = []
				}
			},
			forHtmlSimulation() {
				this.htmlSimulation = false
				const MenuList = localStorage.getItem('MenuList')
				if (MenuList) {
					if (MenuList.includes('htmlSimulation')) {
						this.htmlSimulation = true
					}
				}
			},

			clearFiler() {
				this.isSrc = false
			},
			async loadOssHtml(src) {
				let oss = await this.$oss.getDownloadUrl(src)
				try {
					// 批量释放全部旧blob，防止浏览器回收空白页面
					const releaseBlob = (url) => {
						if (url && url.startsWith('blob:')) URL.revokeObjectURL(url);
					}
					releaseBlob(this.iframeSrc);
					releaseBlob(this.iframeUrlOrigin);
					releaseBlob(this.iframeUrlPlay);
					releaseBlob(this.cachePlaySnapshot);

					const blobUrl = await this.loadOssHtmlBlob(oss)
					this.iframeSrc = URL.createObjectURL(blobUrl);
					this.iframeUrlOrigin = URL.createObjectURL(blobUrl);
					this.iframeUrlPlay = URL.createObjectURL(blobUrl);
					this.$message.success('网页智能体加载完成')
				} catch (err) {
					this.$message.error('读取OSS失败：' + err.message)
					console.error(err)
				}
			},
			async loadOssHtmlBlob(ossUrl) {
				try {
					const res = await fetch(ossUrl, {
						method: "GET",
						mode: "cors"
					});
					if (!res.ok) {
						throw new Error(`OSS请求失败，状态码：${res.status}，链接过期/无跨域权限`);
					}
					const rawBlob = await res.blob();
					const htmlBlob = new Blob([rawBlob], {
						type: "text/html;charset=utf-8"
					});
					// const blobUrl = 
					return htmlBlob;
				} catch (err) {
					this.$message.error('读取OSS失败：' + err.message);
					console.error(err);
					return ''
				}
			},
			clearSingleFiler(index) {
				let newData = JSON.parse(JSON.stringify(this.value || {}));
				newData.htmlList = newData.htmlList.filter(v => v.key != (Number(index) + 1))


				this.$emit('input', newData);
			},
			addNewHtmlRow() {
				let newData = JSON.parse(JSON.stringify(this.value || {}));
				var val = newData.htmlList.length
				let arr = {
					"key": Number(val) + 1,
					"typeId": Number(val) + 1,
					"typeName": "",
					"src": "",
					"htmlId":'',
					"id": null
				}
				newData.htmlList.push(arr)
				this.$emit('input', newData);
			},
			handleChangeSingle(val, index) {
				// console.log(val, index)
				var arr = this.HtmlList.find(v => v.id == index)
				// 2026-07-29 HTML 文件选择保护：找不到当前下拉选项时直接结束，避免写入空的文件信息。
				if (!arr) return
				let newData = JSON.parse(JSON.stringify(this.value || {}));
				console.log('eee',arr)
				newData.htmlList[val].id = index
				newData.htmlList[val].typeName = arr.name
				newData.htmlList[val].src = arr.htmlSrc
				newData.htmlList[val].htmlId=arr.htmlId
				// 2026-07-29 课堂网页选择：把标准模型已有的上传记录主键一并保存。
				// 教师课堂据此查询分层规则；不新增接口，也不改变原有 id 选项值。
				const htmlUploadRecordId = arr.htmlUploadRecordId || arr.htmlUploadId || arr.uploadRecordId || arr.recordId || ''
				if (htmlUploadRecordId) {
					newData.htmlList[val].htmlUploadRecordId = htmlUploadRecordId
				} else {
					delete newData.htmlList[val].htmlUploadRecordId
				}
				const fullData = JSON.parse(JSON.stringify(newData));
				this.$emit('input', fullData);
			},
			// 统一发射完整对象给父组件（所有变更共用此方法，保证全量同步）
			syncToParent(newData) {
				// 深拷贝防止引用污染父组件原对象
				const fullData = JSON.parse(JSON.stringify(newData));
				this.$emit('input', fullData);

			},

			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0,0,0,0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close();
					this.login = null;
				}
			},

			// 标题修改：生成全新完整对象同步
			updateTitle(e) {
				const title = e.target.value;
				const newObj = {
					...this.value,
					title: title
				};
				this.syncToParent(newObj);
			},
			clearFile() {
				this.file = null

			},


			async viewHtml(val) {
				let src = await this.getDetail(this.value.htmlList[val])
				this.loadOssHtml(src)
				this.dialogKey += 1;
				this.dialogVisible = true;
			},
			async getDetail(item) {
				try {
					JSON.stringify()
					const res = await this.API.get(this.API.fileurl.getDetail + "?id=" + item.id)
					return res.data.url

				} catch (err) {
					item.src
				}
			},
			handleCloseDialog() {
				if (this.iframeUrlOrigin) URL.revokeObjectURL(this.iframeUrlOrigin);
				if (this.iframeUrlPlay) URL.revokeObjectURL(this.iframeUrlPlay);
				// if (this.cachePlaySnapshot) URL.revokeObjectURL(this.cachePlaySnapshot);
				this.dialogVisible = false;
			},

		},
		// 页面销毁释放blob
		beforeDestroy() {
			if (this.iframeUrlOrigin) URL.revokeObjectURL(this.iframeUrlOrigin);
			if (this.iframeUrlPlay) URL.revokeObjectURL(this.iframeUrlPlay);
			if (this.cachePlaySnapshot) URL.revokeObjectURL(this.cachePlaySnapshot);
		}
	}
</script>

<style scoped>
	.card {
		background: #fff;
		border-radius: 12px;
		padding: 16px;
		margin-bottom: 16px;
		box-shadow: 0 2px 8px #00000010;
	}

	.card-title {
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 12px;
		color: #333;
	}

	.row {
		display: flex;
		align-items: center;
		gap: 8px;
		margin-bottom: 8px;
	}

	.label {
		width: 110px;
		font-size: 14px;
		color: #666;
	}

	input {
		padding: 6px 10px;
		border: 1px solid #ddd;
		border-radius: 6px;
		font-size: 14px;
	}

	.color-preview {
		width: 20px;
		height: 20px;
		border-radius: 4px;
		border: 1px solid #ddd;
	}

	.native-color-picker {
		width: 30px;
		height: 30px;
		border: none;
		background: none;
		cursor: pointer;
		padding: 0;
	}

	.native-color-picker::-webkit-color-swatch-wrapper {
		padding: 0;
	}

	.native-color-picker::-webkit-color-swatch {
		border-radius: 4px;
		border: 1px solid #ddd;
	}
</style>
